<template>
  <div class="selectrow">
    <label>{{ label }}</label>
    <div class="row">
      <el-select
        :value="value"
        filterable
        class="col-md-8 select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.country"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectCountry',
  props: ['value', 'label'],
  data() {
    return {
      selects: {
        simple: '',
        country: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(`${process.env.VUE_APP_ANNUAIRE_API_URL}/countryEntities?size=450`)
        .then(response => {
          this.selects.country = response.data._embedded.countryEntities
            .sort((a, b) => {
              const labelA = a.name.toUpperCase();
              const labelB = b.name.toUpperCase();
              return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
            })
            .map(entity => ({
              value: entity.id,
              label: entity.name,
            }));
        });
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.selectrow {
  padding-top: 5px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
